import Image from "panels/userSummary/entities/Image";
import { Entity, Field } from "typegraph";

// import Image from "../../entities/Image";

@Entity({one: "user", many: "users"})
export default class User {

	@Field()
	public id: string;

	@Field()
	public externalId: string;

		@Field()
		public firstName: string;

	@Field()
		public lastName: string;

	@Field()
	public displayName: string;

	@Field()
	public email: string;

	@Field({entity: Image})
	public avatar: Image;

}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/entities/User.ts